// تعريف الأعمدة لكل نوع تقرير
export const reportColumnsConfig = {
  invoices_reportes: {
    title: "تقارير الفواتير",
    columns: [
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "customer_id", label: "رقم العميل", width: 100 },
      { key: "sub_total", label: "المجموع الفرعي", width: 120 },
      { key: "tax", label: "الضريبة", width: 100 },
      { key: "discount", label: "الخصم", width: 100 },
      { key: "total_amount", label: "المجموع الكلي", width: 120 },
      { key: "date", label: "التاريخ", width: 120 },
      { key: "created_at", label: "تاريخ الإنشاء", width: 150, format: "datetime" },
    ]
  },

  order_items_reportes: {
    title: "تقارير عناصر الطلبات",
    columns: [
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "product.name", label: "اسم المنتج", width: 150, nested: true },
      { key: "quantity", label: "الكمية", width: 80 },
      { key: "price", label: "السعر", width: 100 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "note", label: "ملاحظات", width: 150 },
      { key: "open_time", label: "وقت الفتح", width: 120 },
      { key: "close_time", label: "وقت الإغلاق", width: 120 },
    ]
  },

  expenese_reportes: {
    title: "تقارير المصروفات",
    columns: [
      { key: "title", label: "العنوان", width: 150 },
      { key: "amount", label: "المبلغ", width: 100 },
      { key: "type", label: "النوع", width: 120 },
      { key: "expense_date", label: "تاريخ المصروف", width: 120 },
      { key: "description", label: "الوصف", width: 200 },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
    ]
  },

  withdrawal_reportes: {
    title: "تقارير السحوبات",
    columns: [
      { key: "amount", label: "المبلغ", width: 100 },
      { key: "withdrawal_title", label: "العنوان", width: 150 },
      { key: "withdrawal_description", label: "الوصف", width: 200 },
      { key: "transaction_date", label: "تاريخ المعاملة", width: 120 },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
    ]
  },

  employee_payroll_reportes: {
    title: "تقارير رواتب الموظفين",
    columns: [
      { key: "employee_statment.employee.name", label: "اسم الموظف", width: 150, nested: true },
      { key: "amount", label: "المبلغ", width: 100 },
      { key: "title", label: "العنوان", width: 150 },
      { key: "expense_date", label: "تاريخ الصرف", width: 120 },
      { key: "employee_statment.action_type", label: "نوع الإجراء", width: 120, nested: true },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
    ]
  },

  deposite_reportes: {
    title: "تقارير الإيداعات",
    columns: [
      { key: "amount", label: "المبلغ", width: 100 },
      { key: "deposit_title", label: "العنوان", width: 150 },
      { key: "deposit_description", label: "الوصف", width: 200 },
      { key: "transaction_date", label: "تاريخ المعاملة", width: 120 },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
    ]
  },

  transfer_reportes: {
    title: "تقارير التحويلات",
    columns: [
      { key: "amount", label: "المبلغ", width: 100 },
      { key: "bank_from_id", label: "من حساب", width: 120 },
      { key: "bank_to_id", label: "إلى حساب", width: 120 },
      { key: "transaction_date", label: "تاريخ المعاملة", width: 120 },
      { key: "note", label: "ملاحظات", width: 200 },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
    ]
  },

  reservation_reportes: {
    title: "تقارير الحجوزات",
    columns: [
      { key: "customer.name", label: "اسم العميل", width: 150, nested: true },
      { key: "customer.phone1", label: "الهاتف", width: 120, nested: true },
      { key: "table.name", label: "الطاولة", width: 100, nested: true },
      { key: "reservation_date", label: "تاريخ الحجز", width: 120 },
      { key: "reservation_time", label: "وقت الحجز", width: 120 },
      { key: "number_of_people", label: "عدد الأشخاص", width: 120 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "reservation_deposit", label: "العربون", width: 100 },
    ]
  },

  offer_orders_reportes: {
    title: "تقارير طلبات العروض",
    columns: [
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "offer.name", label: "اسم العرض", width: 150, nested: true },
      { key: "quantity", label: "الكمية", width: 80 },
      { key: "price", label: "السعر", width: 100 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
    ]
  },

  order_logs_reportes: {
    title: "تقارير سجلات الطلبات",
    columns: [
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "action", label: "الإجراء", width: 120 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "description", label: "الوصف", width: 250 },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
      { key: "created_at", label: "التاريخ", width: 150, format: "datetime" },
    ]
  },

  customer_reportes: {
    title: "تقارير العملاء",
    columns: [
      { key: "name", label: "الاسم", width: 150 },
      { key: "phone1", label: "الهاتف 1", width: 120 },
      { key: "phone2", label: "الهاتف 2", width: 120 },
      { key: "email", label: "البريد الإلكتروني", width: 180 },
      { key: "address1", label: "العنوان 1", width: 200 },
      { key: "created_at", label: "تاريخ التسجيل", width: 150, format: "datetime" },
    ]
  },

  users_reportes: {
    title: "تقارير المستخدمين",
    columns: [
      { key: "id", label: "الرقم", width: 80 },
      { key: "user.name", label: "اسم المستخدم", width: 150, nested: true },
      { key: "user.username", label: "اسم الدخول", width: 120, nested: true },
      { key: "user.type", label: "النوع", width: 150, nested: true },
      { key: "order_type", label: "نوع الطلب", width: 120 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "date", label: "التاريخ", width: 120 },
    ]
  },

  logs_items_reportes: {
    title: "تقارير سجلات العناصر",
    columns: [
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "product.name", label: "المنتج", width: 150, nested: true },
      { key: "quantity", label: "الكمية", width: 80 },
      { key: "price", label: "السعر", width: 100 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "open_time", label: "وقت الفتح", width: 120 },
      { key: "close_time", label: "وقت الإغلاق", width: 120 },
    ]
  },

  captain_order_reportes: {
    title: "تقارير طلبات الكابتن",
    columns: [
      { key: "order_type", label: "نوع الطلب", width: 120 },
      { key: "table_id", label: "رقم الطاولة", width: 100 },
      { key: "captain_order.name", label: "الكابتن", width: 150, nested: true },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "date", label: "التاريخ", width: 120 },
      { key: "open_time", label: "وقت الفتح", width: 120 },
    ]
  },

  order_print_number: {
    title: "تقارير أرقام طباعة الطلبات",
    columns: [
      { key: "order_print_number", label: "رقم الطباعة", width: 120 },
      { key: "user.name", label: "المستخدم", width: 150, nested: true },
      { key: "order_id", label: "رقم الطلب", width: 100 },
      { key: "created_at", label: "تاريخ الإنشاء", width: 150, format: "datetime" },
    ]
  },

  delivery_reportes: {
    title: "تقارير التوصيل",
    columns: [
      { key: "order_type", label: "نوع الطلب", width: 120 },
      { key: "delivery_id", label: "رقم التوصيل", width: 100 },
      { key: "customer_id", label: "رقم العميل", width: 100 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "date", label: "التاريخ", width: 120 },
      { key: "open_time", label: "وقت الفتح", width: 120 },
    ]
  },

  // إضافة تقرير للطلبات عبر الإنترنت
  online_orders_reportes: {
    title: "تقارير الطلبات عبر الإنترنت",
    columns: [
      { key: "order_type", label: "نوع الطلب", width: 120 },
      { key: "root_id", label: "المصدر", width: 100 },
      { key: "customer_id", label: "رقم العميل", width: 100 },
      { key: "table_id", label: "رقم الطاولة", width: 100 },
      { key: "total", label: "الإجمالي", width: 100 },
      { key: "status", label: "الحالة", width: 120, format: "status" },
      { key: "open_time", label: "وقت الفتح", width: 120 },
      { key: "close_time", label: "وقت الإغلاق", width: 120 },
      { key: "date", label: "التاريخ", width: 120, format: "date" },
      { key: "daily_increment", label: "زيادة يومية", width: 120 },
      { key: "monthly_increment", label: "زيادة شهرية", width: 120 },
      { key: "general_increment", label: "زيادة عامة", width: 120 },
      { key: "is_client_order", label: "طلب عميل", width: 120 },
      { key: "order_print_number", label: "رقم الطباعة", width: 120 },
      { key: "invoice.total_amount", label: "المجموع الكلي (فاتورة)", width: 140, nested: true },
      { key: "user.name", label: "المستخدم", width: 120, nested: true },
      { key: "created_at", label: "تاريخ الإنشاء", width: 150, format: "datetime" }
    ]
  },
};

// دالة للحصول على قيمة متداخلة من كائن
export const getNestedValue = (obj, path) => {
  if (!path || !obj) return "-";
  return path.split('.').reduce((current, key) => current?.[key], obj) || "-";
};

// دالة لتنسيق القيم حسب النوع
export const formatValue = (value, format) => {
  if (value === null || value === undefined || value === "") return "-";
  
  switch (format) {
    case "datetime":
      return new Date(value).toLocaleString('ar-EG');
    case "date":
      return new Date(value).toLocaleDateString('ar-EG');
    case "status":
      const statusMap = {
        "open": "مفتوح",
        "close": "مغلق",
        "finished": "منتهي",
        "pending": "معلق",
        "confirmed": "مؤكد",
        "cancelled": "ملغي",
        "out_of_preparation": "خارج التحضير",
        "in_preparation": "قيد التحضير",
      };
      return statusMap[value] || value;
    default:
      return value;
  }
};
